module.exports = __webpack_public_path__ + "media/images/custom_page/younite_event2/younite-event-ko-19ef47d464df521d95bb8cc649a4c49e.png";